import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import employees from 'modules/employees/store/collections/employees'

import BlankSlate from './_BlankSlate'

const ContentLayout = ({ children }: React.PropsWithChildren) => {
  if (employees.isEmpty) return <BlankSlate />

  return (
    <Box flexDirection="column" gap="s32">
      {children}
    </Box>
  )
}

export default observer(ContentLayout)
